import React from 'react'
import { useNavigate, useLocation } from 'react-router-dom';
import { useState } from 'react';
import logo from '../assests/img/logo.png';
import { NavLink, Link } from 'react-router-dom';
import Header from '../Components/Header';
import Footer from '../Components/Footer'

export default function Stallenquiryform() {
  return (
    <div>
      <iframe src="https://aadikaash.com/backend/stallenquiryform/" className='iframe-box'></iframe>
    </div>
  )
}
